import { render, staticRenderFns } from "./App.vue?vue&type=template&id=41fb83a6&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\VS Projects\\SieTest E\\SieTest 4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41fb83a6')) {
      api.createRecord('41fb83a6', component.options)
    } else {
      api.reload('41fb83a6', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=41fb83a6&", function () {
      api.rerender('41fb83a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/sietest/App.vue"
export default component.exports